import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import CashbackMarquee from "@/components/site/CashbackMarquee";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import LandingPage from "@/pages/LandingPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/legal/LegalPage";
import RoutePage from "@/pages/routes/RoutePage";
import { ROUTE_SLUGS } from "@/pages/routes/routesData";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // Update canonical link on route change
    const canonicalHref = `https://ridemateapp.in${pathname === "/" ? "" : pathname}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonicalHref;

    if (hash) {
      // Anchor navigation (e.g. /#waitlist) — scroll to that section instead
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <CashbackMarquee />}
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/privacy" element={<LegalPage />} />
        <Route path="/terms" element={<LegalPage />} />
        <Route path="/safety" element={<LegalPage />} />
        <Route path="/refunds" element={<LegalPage />} />
        <Route path="/legal/:slug" element={<LegalPage />} />
        {ROUTE_SLUGS.map((slug) => (
          <Route key={slug} path={`/${slug}`} element={<RoutePage />} />
        ))}
        <Route path="/routes/:routeSlug" element={<RoutePage />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
        <Toaster
          theme="light"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#ffffff",
              border: "1px solid #e5e7eb",
              color: "#24303F",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
